import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Transition as _Transition } from "vue"
import _imports_0 from '@/assets/icons/attentionRed.svg'


const _hoisted_1 = { class: "frame" }
const _hoisted_2 = {
  key: 0,
  class: "frame__loader"
}
const _hoisted_3 = {
  key: 1,
  class: "frame__inner"
}
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "frame__header" }
const _hoisted_6 = { class: "frame__body" }
const _hoisted_7 = { class: "services-form" }
const _hoisted_8 = { class: "services-form__inner" }
const _hoisted_9 = { class: "services-form__input services-form__tel-number" }
const _hoisted_10 = { class: "services-form__transfer-icon" }
const _hoisted_11 = { class: "services-form__input services-form__account-number" }
const _hoisted_12 = { class: "services-form__input services-form__sum" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "services-form__total" }
const _hoisted_15 = { class: "total" }
const _hoisted_16 = { class: "total__item" }
const _hoisted_17 = { class: "total__text" }
const _hoisted_18 = { class: "total__number" }
const _hoisted_19 = { class: "total__item" }
const _hoisted_20 = { class: "total__text" }
const _hoisted_21 = { class: "total__number" }
const _hoisted_22 = { class: "services-form__btn" }
const _hoisted_23 = {
  key: 1,
  class: "services-form__error services-form-error"
}
const _hoisted_24 = { class: "services-form-error__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ap_loader = _resolveComponent("ap-loader")!
  const _component_Back = _resolveComponent("Back")!
  const _component_ap_input_tel = _resolveComponent("ap-input-tel")!
  const _component_transfer_icon = _resolveComponent("transfer-icon")!
  const _component_ap_input = _resolveComponent("ap-input")!
  const _component_ap_input_money = _resolveComponent("ap-input-money")!
  const _component_ap_button = _resolveComponent("ap-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_ap_loader)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_Back, {
                    title: _ctx.serviceInfo?.name,
                    redirect: _ctx.redirect
                  }, null, 8, ["title", "redirect"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_ap_input_tel, {
                          modelValue: _ctx.servicePaymentDetails.phone,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.servicePaymentDetails.phone) = $event)),
                          label: _ctx.t('phone_number'),
                          "icon-name": _ctx.icon,
                          "error-text": _ctx.serviceError.phone,
                          onKeyup: _ctx.keyup
                        }, null, 8, ["modelValue", "label", "icon-name", "error-text", "onKeyup"])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_transfer_icon)
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_ap_input, {
                          modelValue: _ctx.servicePaymentDetails.accountNumber,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.servicePaymentDetails.accountNumber) = $event)),
                          label: _ctx.accountLabel,
                          "error-text": _ctx.serviceError.identity,
                          hint: _ctx.sumHint,
                          onKeyup: _ctx.onKeyUp
                        }, null, 8, ["modelValue", "label", "error-text", "hint", "onKeyup"])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_ap_input_money, {
                          modelValue: _ctx.servicePaymentDetails.sum,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.servicePaymentDetails.sum) = $event)),
                          label: _ctx.amountLabel,
                          "error-text": _ctx.serviceError.amount,
                          currency: "",
                          max: _ctx.limits.max,
                          onKeyup: _ctx.getCommission
                        }, null, 8, ["modelValue", "label", "error-text", "max", "onKeyup"])
                      ]),
                      (_ctx.serviceInfo.additional !== undefined && _ctx.serviceInfo.additional.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serviceInfo.additional, (field, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "services-form__input services-form__additional"
                              }, [
                                _createVNode(_component_ap_input, {
                                  modelValue: _ctx.servicePaymentDetails[field.code],
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.servicePaymentDetails[field.code]) = $event),
                                  label: field.label,
                                  hint: field.hint,
                                  "error-text": _ctx.serviceError[field.code],
                                  onKeyup: _ctx.onKeyUp
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "hint", "error-text", "onKeyup"])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('commission')), 1),
                            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.servicePaymentDetails.commission || 0) + " ₸ ", 1)
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('total')), 1),
                            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.formatNumber(_ctx.servicePaymentDetails.total) || 0) + " ₸ ", 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_ap_button, {
                          full: true,
                          type: "primary",
                          disable: _ctx.disablePay,
                          onClick: _ctx.payService
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('pay')), 1)
                          ]),
                          _: 1
                        }, 8, ["disable", "onClick"])
                      ]),
                      (_ctx.serviceError.service_id)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "services-form-error__icon" }, [
                              _createElementVNode("img", {
                                src: _imports_0,
                                alt: "",
                                srcset: ""
                              })
                            ], -1)),
                            _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.serviceError.service_id), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ]))
      ]),
      _: 1
    })
  ]))
}